import React from 'react';
import { Platform, View } from 'react-native';
import { SafeAreaView, type Edge } from 'react-native-safe-area-context';
import { useThemeName } from '@tamagui/core';

type Props = {
  children: React.ReactNode;
  edges?: Edge[];
  style?: any;
};

const Screen: React.FC<Props> = ({ children, edges = ['top', 'right', 'left', 'bottom'], style }) => {
  const themeName = useThemeName();
  const backgroundColor = themeName === 'dark' ? '#000000' : '#f5f5f5';

  // On web, simple View with scroll when needed
  if (Platform.OS === 'web') {
    return (
      <View style={[{ flex: 1, height: '100%', backgroundColor, overflow: 'auto' as any }, style]}>
        {children}
      </View>
    );
  }

  return (
    <SafeAreaView style={[{ flex: 1, backgroundColor }, style]} edges={edges}>
      {children}
    </SafeAreaView>
  );
};

export default Screen;
